<div (mouseenter)="showCopyPastAction(true)" (mouseleave)="showCopyPastAction(false)">
    <ng-container *ngIf="showCopyPasteButton && !this.buttonAlignRight">
        <div class="copy left">
            <ng-template *ngTemplateOutlet="copyTemplate; context: {copyText: copyText}"></ng-template>
            <ng-template #copyAnimationView></ng-template>
        </div>
    </ng-container>
    <div class="copy-paste-content">
        <ng-content></ng-content>
    </div>
    <ng-container *ngIf="showCopyPasteButton && this.buttonAlignRight">
        <div class="copy right">
            <ng-template *ngTemplateOutlet="copyTemplate; context: {copyText: copyText}"></ng-template>
            <ng-template #copyAnimationView></ng-template>
        </div>
    </ng-container>
</div>

<ng-template #copyTemplate>
    <div class="copy-paste-action" [ngStyle]="{'background-color' : backgroundColor}">
        <div (click)="copySettlementTableClick($event, copyText)" class="iwp-icon-gen_copy copy-paste" data-cy="copy-paste"></div>
    </div>
</ng-template>

<ng-template #copyAnimationTemplate>
    <div class="copy-paste-action" [ngStyle]="{'background-color' : backgroundColor}">
        <div class="iwp-icon-gen_info_ok copy-paste-animation" data-cy="copy-paste-animation"></div>
    </div>
</ng-template>
